$(document).ready(function () {
  var $selectors = $("[data-contact-select-section]");
  var $sections = $("[data-contact-section]");
  var $form = $(".js-contact-page-form");
  // the toggle of fields is handled by the form.js file, consider removing this
  if ($selectors.length) {
    $sections.hide();

    $selectors.on("click", function () {
      var section = $(this).data("contactSelectSection");
      $sections.hide();
      $sections.find("select").val("");

      $sections.each(function () {
        if ($(this).data("contactSection").indexOf(section) > -1) {
          $(this).show();
        }
      });
    });
  }
  const klaviyoListId = window.theme.global_klaviyo_list_id;
  const siteCode = window.theme.global_klaviyo_site_code;

  // Contact-form-for-trade loads this too, follows for common contact form only and it only functions when there is postcode input field
  const reusableContactForm = document.getElementById("ContactForm");
  const auPostcodeInput = reusableContactForm?.querySelector(
    "#ContactForm-postcode",
  );

  if (reusableContactForm && auPostcodeInput) {
    const auPostcodeInputError = auPostcodeInput
      .closest("[data-form-field]")
      .querySelector(".form-message--error");
    const stateSelect = reusableContactForm.querySelector("#ContactForm-state");
    const postcodeField = auPostcodeInput.closest("[data-form-field]");

    // Validate postcode input for Australia
    auPostcodeInput.addEventListener("change", (event) => {
      if (siteCode === "au") {
        const postcode = event.target.value.trim();
        const state = event.target
          .closest("form")
          .querySelector("[name='contact[State]']").value;
        if (postcode && state && state !== "International") {
          validateAuPostcode(postcode, auPostcodeInputError);
        } else {
          auPostcodeInputError.style.display = "none";
          auPostcodeInput.setCustomValidity("");
        }
      }
    });

    // validate postcode on state change too, i.e., validate AU state but not International
    stateSelect.addEventListener("change", (event) => {
      if (siteCode === "au") {
        const postcode = auPostcodeInput.value;
        const state = event.target.value;

        // Control postcode field visibility and required attribute
        if (state === "International" || state === "" || !state) {
          postcodeField.style.display = "none";
          auPostcodeInput.value = "";
          auPostcodeInput.removeAttribute("required");
          auPostcodeInputError.style.display = "none";
          auPostcodeInput.setCustomValidity("");
        } else {
          postcodeField.style.display = "block";
          auPostcodeInput.setAttribute("required", "");

          // Validate if postcode has value
          if (postcode) {
            validateAuPostcode(postcode, auPostcodeInputError);
          }
        }
      }
    });

    // function to validate postcode for AU only
    function validateAuPostcode(postcode, errorMessage) {
      if (typeof window.isValidAustralianPostcode !== "function") {
        console.warn(
          "isValidAustralianPostcode function is not defined. load postcode-validation before this script.",
        );
        auPostcodeInput.setCustomValidity("Postcode validation unavailable");
        return;
      }
      if (!window.isValidAustralianPostcode(postcode)) {
        errorMessage.style.display = "block";
        errorMessage.textContent = "Please enter a valid Australian postcode.";
        auPostcodeInput.setCustomValidity(
          "Please enter a valid Australian postcode.",
        );
      } else {
        errorMessage.style.display = "none";
        auPostcodeInput.setCustomValidity("");
      }
    }
  }

  function pushProfileToKlaviyo(profile) {
    var settings = {
      async: true,
      crossDomain: true,
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
      },
      data: {
        g: klaviyoListId,
        $fields: "$first_name,$last_name,$source,Customer Type",
      },
    };

    var fieldKeys = Object.entries(profile)
      .map((keyValue) => {
        settings.data[keyValue[0]] = keyValue[1];
        return keyValue[0];
      })
      .join(",");
    settings.data["$fields"] = fieldKeys;

    $.ajax(settings).fail(function () {
      console.log("Error pushing profile to Klaviyo.");
    });
  }

  function submitForm() {
    var identityKeyValue = {};
    var formSelectors = {
      country: {
        selector: '[name="contact[location]"]',
      },
      customerType: {
        selector: '[name="contact[Enquiry Type]"]:checked',
      },
      state: {
        selector: '[name="contact[State]"]',
      },
      postcode: {
        selector: '[name="contact[Postcode]"]',
      },
      organisation: {
        selector: '[name="contact[Company]"]',
      },
      formIdentifier: {
        selector: '[name="contact[form_identifier]"]',
      },
    };
    var enquiryEventFieldsToTrack = [
      {
        selector: '[name="contact[body]"]',
        klaviyoFieldName: "enquiry",
      },
      {
        selector: '[name="contact[Enquiry Type]"]:checked',
        klaviyoFieldName: "enquiry_type",
      },
      {
        selector: '[name="contact[Contact Reason]"]',
        klaviyoFieldName: "contact_reason",
      },
      {
        selector: '[name="contact[Preferred Contact Method]"]:checked',
        klaviyoFieldName: "preferred_contact_method",
      },
      {
        selector: '[name="contact[form_identifier]"]',
        klaviyoFieldName: "form_identifier",
      },
    ];
    var identityFieldsToTrack = [
      {
        selector: '[name="contact[First Name]"]',
        klaviyoFieldName: "$first_name",
      },
      {
        selector: '[name="contact[Last Name]"]',
        klaviyoFieldName: "$last_name",
      },
      {
        selector: '[name="contact[email]"]',
        klaviyoFieldName: "$email",
      },
      {
        selector: '[name="contact[phone]"]',
        klaviyoFieldName: "$phone_number",
      },
      {
        selector: '[name="contact[Enquiry Type]"]:checked',
        klaviyoFieldName: "Customer Type",
      },
    ];
    var enquiryEventKeyValue = {};
    var signUpToNewsletter = $('[name="contact[tags]"]').is(":checked");
    var customerType = $(formSelectors.customerType.selector).val();
    var organisation = $(formSelectors.organisation.selector).val();
    var formIdentifier = $(formSelectors.formIdentifier.selector).val();

    if (customerType === "Commercial" && organisation && organisation.length) {
      identityFieldsToTrack.push({
        selector: '[name="contact[Company]"]',
        klaviyoFieldName: "$organization",
      });
      enquiryEventFieldsToTrack.push({
        selector: '[name="contact[Company]"]',
        klaviyoFieldName: "organization",
      });
    }

    // Process Default Profile Fields
    identityFieldsToTrack.forEach(function (identityField) {
      var $element = $form.find(identityField.selector);
      var elementType = $($element).attr("type");
      var elementValue = $element.val();
      var elementValue =
        elementType === "checkbox" ? $element.is(":checked") : $element.val();
      identityKeyValue[identityField.klaviyoFieldName] = elementValue;
    });

    // Process Enquiry Event Fields
    enquiryEventFieldsToTrack.forEach(function (enquiryField) {
      var $element = $form.find(enquiryField.selector);
      var elementValue = $element.val();
      enquiryEventKeyValue[enquiryField.klaviyoFieldName] = elementValue;
    });

    // Process Location/State Fields
    if (siteCode === "au") {
      var state = $(formSelectors.state.selector).val();
      var postcodeInput = $(formSelectors.postcode.selector).val();
      var postcode = postcodeInput ? postcodeInput.trim() : "";

      if (state !== "International") {
        identityKeyValue["$country"] = "Australia";
        identityKeyValue["$region"] = state;
        identityKeyValue["$zip"] = postcode;

        enquiryEventKeyValue["enquiry_location"] =
          state + "  " + postcode + ", Australia";
        enquiryEventKeyValue["postcode"] = postcode;
      } else {
        identityKeyValue["$country"] = "International";
        enquiryEventKeyValue["enquiry_location"] = "International";
      }
    }

    if (siteCode === "sg") {
      var country = $(formSelectors.country.selector).val();
      identityKeyValue["$country"] = country;
      // to be future proof for SG site
      enquiryEventKeyValue["enquiry_location"] = country;
    }

    // get $source from hidden field
    var source =
      formIdentifier && formIdentifier.length ? formIdentifier : "Contact Form";

    if (signUpToNewsletter) {
      identityKeyValue["$source"] = source;
      pushProfileToKlaviyo(identityKeyValue);
    }

    // Define Klaviyo Object
    var klaviyo = window.klaviyo || [];

    function onIdentifyCompleteCallback() {
      klaviyo.push(["track", "Contact Enquiry", enquiryEventKeyValue]);
    }

    klaviyo.identify(identityKeyValue, onIdentifyCompleteCallback);

    window.dataLayer.push({
      event: "contact-form-submit",
      formIdentifier:
        formIdentifier || document.title.replace(" | Space Furniture", ""),
      customerType: customerType,
      organisation: organisation || "",
      enquiryType: enquiryEventKeyValue["contact_reason"] || "",
    });
  }

  $form.on("submit", function (e) {
    // Check if the form is valid
    if (!this.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    submitForm();
  });
});
